/* BudBabes — TikTok mobile nav dots.
   On phones the TikTok video iframes swallow horizontal swipes, so the CSS
   scroll-snap strip is almost impossible to move. This adds a dots strip BELOW
   the videos that reliably controls the carousel: tap a dot to jump to a video,
   or swipe across the strip to go prev/next. Mobile only; desktop keeps Splide's
   own navigation. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');

  function build(splide) {
    if (!MQ.matches) return;
    var track = splide.querySelector('.splide__track');
    if (!track) return;
    // Only when the track is actually a horizontal scroll strip (our mobile mode).
    if (track.scrollWidth <= track.clientWidth + 4) return;

    var slides = Array.prototype.slice.call(splide.querySelectorAll('.splide__list > .splide__slide'));
    if (slides.length < 2) return;

    var existing = splide.querySelector('.bb-tt-dots');
    if (existing && existing.children.length === slides.length) return; // already correct
    if (existing) existing.remove(); // slide count changed -> rebuild

    var current = 0;

    function setActive(i) {
      if (i < 0 || i >= dots.length) return;
      current = i;
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === i);
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var target = track.scrollLeft + (slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left);
      if (track.scrollTo) track.scrollTo({ left: target, behavior: 'smooth' });
      else track.scrollLeft = target;
      setActive(i);
    }

    var strip = document.createElement('div');
    strip.className = 'bb-tt-dots';
    strip.setAttribute('aria-label', 'Video navigation');

    var dots = slides.map(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bb-tt-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to video ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      strip.appendChild(b);
      return b;
    });

    // Active dot follows manual scrolling of the strip.
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var edge = track.getBoundingClientRect().left;
        var best = 0, bestD = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].getBoundingClientRect().left - edge);
          if (d < bestD) { bestD = d; best = i; }
        }
        setActive(best);
      });
    }, { passive: true });

    // Swipe across the dots strip -> prev/next (the strip doesn't eat touches like the videos do).
    var sx = null, sy = null;
    strip.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    strip.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 28 && Math.abs(dx) > Math.abs(dy)) goTo(current + (dx < 0 ? 1 : -1));
      sx = sy = null;
    }, { passive: true });

    splide.appendChild(strip);
  }

  function sync() {
    document.querySelectorAll('.tiktok-videos .splide').forEach(build);
  }
  function boot() { sync(); setTimeout(sync, 500); } // 2nd pass after Splide settles/destroys on mobile

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  if (MQ.addEventListener) MQ.addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
})();


/* Lazy-load TikTok's embed.js only when a video section nears the viewport.
   The embed script + players are heavy and the sections sit far below the fold,
   so keeping them off the initial load is a big mobile-performance win. */
(function () {
  var sections = document.querySelectorAll('.tiktok-videos');
  if (!sections.length) return;
  var loaded = false;
  function load() {
    if (loaded) return; loaded = true;
    var s = document.createElement('script');
    s.src = 'https://www.tiktok.com/embed.js';
    s.async = true;
    document.body.appendChild(s);
  }
  if (!('IntersectionObserver' in window)) { load(); return; }
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) { load(); io.disconnect(); break; }
    }
  }, { rootMargin: '600px 0px' });
  sections.forEach(function (s) { io.observe(s); });
})();
